import iposApi from '../../api/iposApi';
import {generateOrderItem, getItemType} from '../../helpers/common';
import {currentDeliveryItem, orderTotal} from '../selectors/order';
import {hideLoading, showLoading} from './loadingActions';
import {saveBranchInfo} from './branchActions';
import {loadtMenuItemTypes, storeMenuItems} from './menuActions';
import {setClientInfo} from './clientActions';
import {setPayments} from './paymentActions';
import {currentUiLanguageId} from '../reducers/baseReducers';

export const addToOrderAction = data => ({
  type: 'ADD_TO_ORDER',
  data,
});

export const updateOrderItem = data => ({
  type: 'UPDATE_ORDER_ITEM',
  data,
});

export const deleteOrderItem = data => ({
  type: 'DELETE_ORDER_ITEM',
  data,
});

export const clearOrder = () => ({
  type: 'CLEAR_ORDER'
});

export const setOrderType = data => ({
  type: 'SET_ORDER_TYPE',
  data
});

export const setOrderDateTime = data => ({
  type: 'SET_ORDER_DATE_TIME',
  data
});

export const setOrderInfo = data => ({
  type: 'SET_ORDER_INFO',
  data
});

export const setCurrentOrderItem = data => ({
  type: 'SET_CURRENT_ORDER_ITEM',
  data
});

export const cancelSelection = () => ({
  type: 'CANCEL_SELECTION'
});

export const addToOrder = (item, quantity) => async (dispatch, getState) => {
  const {orderItems} = getState();

  const existingItem = orderItems.find(i => i.guidCode === item.guidCode);

  if (existingItem) {
    // dispatch(changeItemQuantity(existingItem, existingItem.orderItem.quantity + 1));
    dispatch(updateOrderItem(item));
    return;
  }

  dispatch(addToOrderAction(item));
};

const createNewItem = (menuItem, orderItem) => (dispatch, getState) => {
  const {menuItemTypes} = getState();
  const isRootItem = !orderItem.parent_id && !orderItem.parent_uid;
  const isShareItem = orderItem.share_id !== null && orderItem.share_index !== null;
  const shareIndexId = (orderItem.share_id !== null && orderItem.share_index !== null) ? `${orderItem.share_id}_${orderItem.share_index}` : null;
  const isShareRootItem = isShareItem && orderItem.free_instruction_text !== null;

  return {
    id: orderItem.order_menu_item_id,
    guidCode: orderItem.guid_code,
    isRootItem: (isRootItem && !isShareItem) || isShareRootItem,
    isShareItem,
    isShareRootItem,
    shareIndexId,
    orderItem: orderItem,
    menuItem: menuItem,
    menuItemType: getItemType(menuItem, menuItemTypes),
  };
};

const OrderTypeMapping = {
  'DELIVERY': 1,
  'TA': 2,
  'EAT_IN': 3.
};

export const submitOrder = (paymentData, guidCode = null, confCode = null) => async (dispatch, getState) => {
  const state = getState();
  const {
    branchInfo,
    orderGuidCode,
    clientInfo,
    orderItems,
    currentLanguageId,
    currentDeliveryType,
    orderDateTime,
    currentTableId,
    valuecardInfo,
    valuecardItem,
    valueCardBenefitsResponse,
  } = state;



  // dispatch(showLoading());

  //const totalAmount = orderTotal(state);
  const deliveryItem = currentDeliveryItem(state);

  const url = '/SubmitOrder';
  let orderData = {};
  orderData.order_guid_code = orderGuidCode;
  orderData.order_type = OrderTypeMapping[currentDeliveryType];
  orderData.branch_id = branchInfo.branch_guid_code;
  orderData.language_id = currentLanguageId;
  orderData.client_info = clientInfo;
  orderData.delivery_time = orderDateTime;
  orderData.order_items = collectOrderItems(orderItems);
  orderData.guid_code = guidCode;
  orderData.confirmation_code = confCode;
  orderData.room_item_id = currentTableId;
  orderData.create_order_type = 1;    // 0 - ipos 1 - delivery site 2 - kiosk site
  if (valueCardBenefitsResponse) {
    orderData.value_card_id = valueCardBenefitsResponse.transactionId;    
    orderData.valuecard_client_name = valueCardBenefitsResponse.memberFullName;
    if (valuecardInfo) {
      orderData.valuecard_number = valuecardInfo.memberCardNumber;
    }
    if (valuecardItem) {
      orderData.order_items.push(valuecardItem.orderItem);
    }
  }  

  if (deliveryItem) {
    orderData.order_items.push(deliveryItem.orderItem);
  }

  // orderData.payment_delivery = {
  //   payment_type_id: paymentType.payment_type_id,
  //   amount: totalAmount,
  //   card_number: cardData && cardData.cardNumber.replaceAll(/\s/g,''),
  //   exp_date: cardData && `${cardData.expiryMonth} / ${cardData.expiryYear}`,
  //   cvv: cardData && cardData.cvc,
  //   passport_id: cardData && cardData.passport
  // };
  //
  // if (branchInfo.use_pin_pad_flg === 1) {
  //   orderData.payment_delivery.pin_pad_id = branchInfo.pin_pad_id;
  // }
  orderData.payment_delivery = paymentData;

  try {
    const response = await iposApi.post(url, orderData);

    dispatch(hideLoading());
    return await response.data;
    // await dispatch(onSubmitOrder(response.data));
    // dispatch(hideLoading());
  } catch (error) {
    // dispatch(hideLoading());
    dispatch(() => ({type: 'ERROR', data: error}));
    dispatch(hideLoading());
  }
};

const languageMapping = {
  1: 'En',
  2: 'He',
  3: 'Ru'
};

export const dejavooCreateSession = () => async (dispatch, getState) => {
  const state = getState();
  const {
    branchInfo,
    clientInfo,
    orderItems,
    currentLanguageId,
    currentUiLanguageId,
    currentDeliveryType,
    orderDateTime,
    currentTableId,
    orderTips
  } = state;

  dispatch(showLoading());

  const totalAmount = orderTotal(state);
  const deliveryItem = currentDeliveryItem(state);

  const url = '/DejavooCreateSession';
  let orderData = {};

  orderData.ios_platform = navigator.userAgent.indexOf("iPhone") > 0;
  orderData.order_type = OrderTypeMapping[currentDeliveryType];
  orderData.branch_id = branchInfo.branch_guid_code;
  orderData.language_id = currentLanguageId;
  orderData.language_code = languageMapping[currentUiLanguageId];
  orderData.client_info = clientInfo;
  orderData.delivery_time = orderDateTime;
  orderData.order_items = collectOrderItems(orderItems);
  orderData.room_item_id = currentTableId;
  orderData.tips = orderTips;
  orderData.order_amount = totalAmount
  if (deliveryItem) {
    orderData.order_items.push(deliveryItem.orderItem);
  }

  // orderData.payment_delivery = {
  //   payment_type_id: paymentType.payment_type_id,
  //   amount: totalAmount,
  //   card_number: cardData && cardData.cardNumber.replaceAll(/\s/g,''),
  //   exp_date: cardData && `${cardData.expiryMonth} / ${cardData.expiryYear}`,
  //   cvv: cardData && cardData.cvc,
  //   passport_id: cardData && cardData.passport
  // };
  //
  // if (branchInfo.use_pin_pad_flg === 1) {
  //   orderData.payment_delivery.pin_pad_id = branchInfo.pin_pad_id;
  // }

  try {
    const response = await iposApi.post(url, orderData);

    dispatch(hideLoading());
    return await response.data;
    // await dispatch(onSubmitOrder(response.data));
    // dispatch(hideLoading());
  } catch (error) {
    // dispatch(hideLoading());
    dispatch(() => ({type: 'ERROR', data: error}));
    dispatch(hideLoading());
  }
};

export const collectOrderItems = (orderItems) => {
  return orderItems.map((item) => {
    const supplements = [...item.supplements.map(s => s.orderItem), ...item.instructions.map(i => i.orderItem)];

    const newItem = item.orderItem;
    newItem.supplements = supplements;
    if (item.freeInstruction) {
      newItem.free_text = item.freeInstruction;
    }

    newItem.is_business_lunch_supplement_flg = false;
    newItem.business_category_id = item.category ? item.category.menu_item_id : null;

    if (newItem.is_business_lunch_flg === 1 || newItem.is_kiosk_item_flg === 1) {
      newItem.business_lunch_items = collectOrderItems(item.lunchItems);
    }

    return newItem;
  });
};

export const changeItemQuantity = (item, newQuantity) => async (dispatch, getState) => {
  const currentItem = Object.assign({}, item);

  const {orderItems} = getState();

  currentItem.orderItem.quantity = newQuantity;
  for (const supplement of currentItem.supplements) {
    supplement.orderItem.quantity = newQuantity;
  }

  dispatch(updateOrderItem(currentItem));
};

export const loadOrderInfo = (branchUuid, orderUuid, languageId = 1) => async (dispatch, getState) => {
  const url = '/GetOrderInfo';
  const params = {
    branchId: branchUuid,
    order_code: orderUuid,
    language_id: languageId
  };

  const response = await iposApi.get(url, {params});

  if (!response || !response.data || response.data.error_message) {
    // await dispatch(hideLoading());
    return response.data;
  }

  const branchInfo = response.data.branchInfo;
  branchInfo.branch_guid_code = branchUuid;
  await dispatch(saveBranchInfo(branchInfo));
  await dispatch(loadtMenuItemTypes());
  await dispatch(storeMenuItems(response.data.listMenuIems));
  await dispatch(setClientInfo(response.data.client));

  const orderInfo = response.data.order;
  orderInfo.paymentsName = response.data.paymentsName.join(', ');
  orderInfo.table_number = response.data.table_number;
  orderInfo.employee_name = response.data.employee_name;
  await dispatch(setOrderInfo(orderInfo));

  const payments = response.data.payments;
  await dispatch(setPayments(payments));

  const {menuItemTypes} = getState();

  const orderItems = [];

  for await (let orderItem of response.data.listOrderMenuIems) {
    if (orderItem.menu_item_id !== null) {
      const menuItem = response.data.listMenuIems.find(oi => oi.menu_item_id === orderItem.menu_item_id);
      const item = generateOrderItem(menuItem, menuItemTypes, {
        customPrice: null,
        newQuantity: 1,
        currentOrderItem: orderItem
      });
      orderItems.push(item);
    }
  }

  for await (let item of orderItems) {
    if (item.orderItem.parent_id !== null) {
      continue;
    }

    const parentItem = item;
    const supplements = orderItems.filter(oi => oi.orderItem.parent_id === parentItem.orderItem.order_menu_item_id && ['SUPPLEMENT', 'BOTTLE_ITEM'].includes(oi.menuItemType));
    const instructions = orderItems.filter(oi => oi.orderItem.parent_id === parentItem.orderItem.order_menu_item_id && oi.menuItemType === 'PREPARATION_INSTRUCTION');
    const freeInstruction = response.data.listOrderMenuIems.find(oi => oi.parent_id === parentItem.orderItem.order_menu_item_id && oi.menu_item_id === null);

    parentItem.instructions = instructions;
    parentItem.supplements = supplements;
    if (freeInstruction) {
      parentItem.freeInstruction = freeInstruction.free_instruction_text;
    }
    await dispatch(addToOrder(parentItem));
  }

  //await dispatch(hideLoading());
  return response.data;
};

export const loadDocumentInfo = (branchUuid, languageId = 1, documentCode) => async (dispatch, getState) => {
  const url = '/GetDocumentInfo';
  const params = {
    branchId: branchUuid,
    document_code: documentCode,
    language_id: languageId
  };

  const response = await iposApi.get(url, {params});

  if (response.data.error_message || response.data === '') {
    return response.data;
  }

  const branchInfo = response.data.branchInfo;
  branchInfo.branch_guid_code = branchUuid;
  await dispatch(saveBranchInfo(branchInfo));
  await dispatch(loadtMenuItemTypes());
  await dispatch(storeMenuItems(response.data.listMenuIems));
  // await dispatch(setClientInfo(response.data.client));

  const orderInfo = response.data.order;
  orderInfo.paymentsName = response.data.paymentsName.join(', ');
  await dispatch(setOrderInfo(orderInfo));

  const {menuItemTypes} = getState();

  const orderItems = [];

  for await (let orderItem of response.data.listOrderMenuIems) {
    if (orderItem.menu_item_id !== null) {
      const menuItem = response.data.listMenuIems.find(oi => oi.menu_item_id === orderItem.menu_item_id);
      const item = generateOrderItem(menuItem, menuItemTypes, {
        customPrice: null,
        newQuantity: 1,
        currentOrderItem: orderItem
      });
      orderItems.push(item);
    }
  }

  for await (let item of orderItems) {
    if (item.orderItem.parent_id !== null) {
      continue;
    }

    const parentItem = item;
    const supplements = orderItems.filter(oi => oi.orderItem.parent_id === parentItem.orderItem.order_menu_item_id && ['SUPPLEMENT', 'BOTTLE_ITEM'].includes(oi.menuItemType));
    const instructions = orderItems.filter(oi => oi.orderItem.parent_id === parentItem.orderItem.order_menu_item_id && oi.menuItemType === 'PREPARATION_INSTRUCTION');
    const freeInstruction = response.data.listOrderMenuIems.find(oi => oi.parent_id === parentItem.orderItem.order_menu_item_id && oi.menu_item_id === null);

    parentItem.instructions = instructions;
    parentItem.supplements = supplements;
    if (freeInstruction) {
      parentItem.freeInstruction = freeInstruction.free_instruction_text;
    }
    await dispatch(addToOrder(parentItem));
  }

  await dispatch(hideLoading());
  return response.data;
};

